import { SVG, SVGProps } from './svg'

export function IconToolLine(props: SVGProps) {
  return (
    <SVG {...props} fill="none" stroke={props.fill} viewBox="0 0 32 32">
      <path d="M22 8a2 2 0 111 1.7L9.7 23c.2.3.3.6.3 1a2 2 0 11-1-1.7L22.3 9a2 2 0 01-.3-1zm2-1a1 1 0 100 2 1 1 0 000-2zM8 23a1 1 0 100 2 1 1 0 000-2z" />
    </SVG>
  )
}
